// extracted by mini-css-extract-plugin
export var testimonial = "style-mod--testimonial--0575e";
export var testimonialCard = "style-mod--testimonial-card--530a0";
export var testimonialCardPlay = "style-mod--testimonial-card-play--b9a37";
export var testimonialCardTitle = "style-mod--testimonial-card-title--c8fe3";
export var testimonialCardTitleMain = "style-mod--testimonial-card-title-main--e6214";
export var testimonialCardVideo = "style-mod--testimonial-card-video--bfff3";
export var testimonialCardVideoButton = "style-mod--testimonial-card-video-button--0f19e";
export var testimonialCardVideoButtonContainer = "style-mod--testimonial-card-video-button-container--77cba";
export var testimonialSlider = "style-mod--testimonial-slider--c0a67";
export var testimonialVideoText = "style-mod--testimonial-video-text--19d45";
export var testimonialVideoTextIcon = "style-mod--testimonial-video-text-icon--003f5";
export var testimonialVideoTextParagraph = "style-mod--testimonial-video-text-paragraph--4871e";